import { render, staticRenderFns } from "./Ordering.vue?vue&type=template&id=8d172a2a&scoped=true&"
import script from "./Ordering.vue?vue&type=script&lang=js&"
export * from "./Ordering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d172a2a",
  null
  
)

export default component.exports